import React from 'react';
import { AwarenessTemplate } from '../components/training/templates/AwarenessTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getAwarenessContent } from '../data/standards/trainingContent';

export const ISO22000Awareness = () => {
  const standard = getStandardBySlug('iso-22000');
  const content = getAwarenessContent('iso-22000');

  return <AwarenessTemplate standard={standard} content={content} />;
};
